<template lang="">
  <div>
    <Header
      title="Disparos Automáticos"
      subtitle="Automação de disparos"
      hasSeparator
    ></Header>
    
    <template>
      <v-tabs
        v-model="tab"
        color='black'
        class="d-flex justify-start"
      >
        <v-tab href="#communication" name="communication" class="mb-2">
          <img width="20" src="../../../../static/images/communication.svg"/>
          <span class="pl-3 ff" @click="redirectToTab">Comunicacões</span>
        </v-tab>
        <v-tab href="#copys" name="copys" class="mb-2">
          <img width="20" src="../../../../static/images/copies.svg"/>
          <span class="pl-3 ff">Copys</span>
        </v-tab>
        <v-tab href="#produto" name="produto" class="mb-2">
          <img width="20" src="../../../../static/images/products.svg"/>
          <span class="pl-3 ff">Produtos</span>
        </v-tab>
      </v-tabs>
    </template>
    <hr>
    
    <div v-if="tab === 'communication'">
      <div>
        <v-btn
          v-if="newCampaign"
          class="pa-5 my-11 b"
          height="50px"
          outlined
          @click="redirectToRegister">
          <img class="pr-3" src="../../../../static/images/add-circle-black.svg"/><span class="ff">Nova campanha</span>
        </v-btn>
      </div>
      <component :is="currentView"></component>
    </div>
    <div v-if="tab === 'copys'">
      <Copy />
    </div>
    <div v-if="tab === 'produto'">
      <Product />
    </div>    
  </div>
</template>
<script>
// Store
import { mapState, mapMutations } from 'vuex'

// Components
import Header from '@/components/Header.vue'
import Communication from '@/components/Contents/AutomaticsTriggers/Communication.vue'
import Copy from '@/components/Contents/AutomaticsTriggers/Copy.vue'
import Product from '@/components/Contents/AutomaticsTriggers/Product.vue'
import NewCommunication from '@/components/Contents/AutomaticsTriggers/NewCommunication.vue'


export default {
  components: {
    Header,
    Communication,
    Product,
    Copy,
    NewCommunication
  },
  data () {
    return {
      currentPage: 1,
      perPage: 30,
      tab: 'communication',
      text: 1,
      // newCampaign: true,
      currentView: Communication
    }
  },
  computed: {
    ...mapState('Communication', {
      newCampaign: 'newCampaign'
    })
  },
  methods: {
    ...mapMutations('Communication', {
      setNewTab: 'SET_TAB_NEW_COMMUNICATION',
      unsetCommunicationToEdit: 'UNSET_COMMUNICATION_TO_EDIT',
    }),
    redirectToRegister () {
      this.unsetCommunicationToEdit()
      this.currentView = NewCommunication
      this.setNewTab(false)
    },
    redirectToTab () {
      this.currentView = Communication
      this.setNewTab(true)
    }
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
.ff {
  font-family: 'DM Sans Regular', sans-serif !important;
  text-transform: capitalize;
}

thead {
  background: var(--grey-day-020);
  height: 64px;
  font-size: 16px !important;
}

th {
  height: 64px;
  font-size: 16px;
  color: var(--neutral-black);
}

 /*  Toggle Switch  */
.status--toggle {
  width: auto !important;
}

.b {
  border: 2px solid var(--grey-day-030);
  border-radius: 4px;
}

.v-pagination__navigation, .v-pagination__item {
  border: none;
  box-shadow: none
}

// transition

</style>


// WEBPACK FOOTER //
// src/components/Contents/AutomaticsTriggers/AutomaticTriggersView.vue